import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

export default function VideoCard({ video }: { video: Video }) {
  const formatViews = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    return n.toLocaleString();
  };

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={video.cover}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={video.title}
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
            {video.quality}
          </span>
        </div>
        <div className="absolute bottom-2 right-2">
          <span className="px-1.5 py-0.5 rounded text-[10px] bg-background-950/70 text-foreground-200 backdrop-blur-sm">
            {video.duration}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/90">
            <i className="ri-play-fill text-foreground-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-100 line-clamp-2 group-hover:text-accent-500 transition-colors mb-1.5 leading-snug">
        {video.title}
      </h3>

      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {formatViews(video.views)}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500"></i>
          {video.rating}
        </span>
      </div>
    </Link>
  );
}